import * as z from 'zod';

export const initialValue = 9;
export const JobChangeCounts = [0, 1, 2, 3, initialValue] as const;

export const numberOfJobChangeSchema = z.number();

export type FormSchema = z.infer<typeof numberOfJobChangeSchema>;
